import
  React
from 'react';

import {
  useHistory,
  useLocation
} from 'react-router-dom';

import {
  Text,
  VFillContainer,
  VFillContainerH
} from '@vodacom/web-common';

import {
  BackButton,
  TabView
} from 'components';

import {
  CustomColors,
  VoucherDetailTabs
} from '../../../../constants';

import {
  RedemptionsTab,
  SummaryTab
} from '../components';

export const VoucherAdvanceDetail = (props) => {

  const location = useLocation();
  const history = useHistory();
  const item = location.state?.voucherHistory;

  const Content = () => {

    return (

      <VFillContainer>

        <BackButton
          onClick={() => history.goBack()}
          margin={'16px 20px'}/>

        <Text
          fontSize={'26px'}
          padding={'0 20px 16px'}
          color={CustomColors.Grey11}
          fontWeight={'bold'}>

          {'Voucher detail'}
        </Text>

        <VFillContainerH
          padding={'16px 8px 32px'}
          backgroundColor={CustomColors.Grey19}>

        <TabView
          width={'100%'}
          tabData={[
            {
              'value': VoucherDetailTabs[0]?.value,
              'component': <SummaryTab {...item}/>
            },
            {
              'value': VoucherDetailTabs[1]?.value,
              'component': <RedemptionsTab {...item}/>
            }
          ]}
          tabList={VoucherDetailTabs}
          flex={'0 0 auto'}
          justifyContent={'center'}
          borderBottom={`solid 3px ${CustomColors.Grey20}`}
          borderBottomSize={'-3px'}
          onTabClick={() => {

          }}/>

        </VFillContainerH>

      </VFillContainer>
    );
  };

  return <Content/>;
};